import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import BackgroundD from '../../../static/images/marchamos/Hero-img.jpg'
import BackgroundM from '../../../static/images/marchamos/Hero-img-Mob.jpg'

const Container = styled.div`
  background-image:url(${BackgroundM});
  background-repeat: no-repeat;
  background-position:center;
  background-size: cover;
  position: relative;
  text-align: center;
  margin: 0 auto;
  ${breakpoint('tablet')`
    background-image:url(${BackgroundD}) !important;
  `}
  h1 {
    font-size: 2.8em;
    margin: 0 0 0.3em;
    color: black;
  }

  h2 {
    font-size: 1.2em;
    font-weight: 400;
    color: ${props => props.theme.colors.grisOscuro};
    margin: 0 0 0.5em;
  }

  h3 {
    font-size: 19px;
    font-weight: 400;
  }

  p {
    color: ${props => props.theme.colors.grisOscuro};
    margin-bottom: 0 0 1.5em;
  }

 

  ${breakpoint('tablet')`
    & h1:first-child {
      font-size: 40px !important;
    }

    h2{
      font-size: 2em;
    }

    a {
      font-size: 1.3em;
    }
  `}

  video {
    max-width: 100%;
  }
`

const Wrapper = styled.div`
  padding: 3em 2em;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    display: flex;
    text-align: left;
    justify-content: center;

    & > div {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 100%;

      box-sizing: border-box;
    }

    & > div:first-of-type {
      padding-right: 20px;
    }
  `}
`

const H1 = styled.h1 `
    margin-top: -27px !important;
    font-weight: 600;
    font-size: 50px !important;
    color:${props => props.theme.colors.rojoBac}!important;
    ${breakpoint('tablet')`
        font-size:80px !important;
        margin-top: -37px !important;
    `}
`


const Reverse = styled.div `
    width: 100%;
    margin-top:300px;

    & h1 {
        color: black;
        font-weight: 600; 
        font-size:40px;
        ${breakpoint('tablet')`
            font-size:80px
        `}
    }

    & h3 {
      
        ${breakpoint('tablet')`
                margin-top: -10px;
                margin-bottom:100px;
                width:50%;
        `}
    }

    ${breakpoint('tablet')`
        flex-direction: row-reverse;
        display: flex;
        margin-top:0;
   `}

    ${breakpoint('desktop')`
        margin-bottom: -60px;
    `}
`


const Header = ({ formUrl, multicanalidad, pais }) => (
  <Container>
    <Wrapper>
        <Reverse>

      <div style={{"width" : "100%"}}>
        <h1>Ya estás a un</h1>
        <h1 style={{marginTop:-30}}>marchamo</h1>
        <H1>de ganar</H1>
        <h3>Pagá tu marchamo con BAC Credomatic y podrás ser uno de los 2 ganadores de grandes premios. Aprovechá nuestras opciones de pago.</h3>
      </div>
      </Reverse>
    </Wrapper>
  </Container>
);

export default Header